import {useThemeColors} from '@nfq/colors';

/**
 * The `useOnlineShops` hook manages the online shops section state by providing theme colors.
 * It retrieves the current theme color palette.
 *
 * @returns An object containing `colors` with the current theme color palette.
 *
 * @example
 * ```tsx
 * const {colors} = useOnlineShops();
 *
 * return (
 *   <div style={{color: colors.primary}}>
 *     <p>Welcome to our online shops!</p>
 *   </div>
 * );
 * ```
 */
export const useOnlineShops = () => {
    const colors = useThemeColors();

    return {colors};
};